
import "./turmas.css"
import { useEffect, useState } from "react"
import FormTurma from "../../Forms/Cadastro"
import { getItens } from "../../../firebase/CRUD"
import { useAuth } from "../../../hooks/AuthContext"
import ContainerLista from "../../layout/ContainerLista/ContainerLista"
import TurmaFicha from "./TurmaFicha"
import TurmaAdd from "./TurmaAdd"

export default function Turmas(){
    const {usuario} = useAuth()
    const [turmas,setTurmas] = useState([])
    const [cadastramento,setCadastramento] = useState(false)
    const [carregando,setCarregando] = useState(true)
    useEffect(()=>{
        const dados = (dt)=>{
            if(dt){
                console.log(dt)
                setTurmas(dt)
            }
            setCarregando(false)
        }
        return getItens("turmas",dados,usuario.idEscola)
    },[])

    const ativarCadastramento = ()=>{
        setCadastramento(true)
    }
    const desativarCadastramento = ()=>{
        setCadastramento(false)
    }

    return(
        <div style={{width: "100%"}}>
            <ContainerLista itensLista={turmas} pagina={ "Turmas"} cadastramento={ativarCadastramento} carregando={carregando}>
                {turmas.length > 0 && 
                    turmas.map((item,id)=>
                        // CORREÇÃO: era key={item.key}, campo que não existe
                        // (os itens vêm de getItens como {id, ...dados}, nunca
                        // com um campo "key"). Gerava warning do React e
                        // reconciliação errada da lista ao adicionar/remover.
                        <TurmaFicha turma={item} key={item.id}/>
                    )
                }
            </ContainerLista>
            {cadastramento && <TurmaAdd cadastramento={desativarCadastramento}/>}
            
        </div>
    )
}